import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchProcessingList({ commit }) {
    return new Promise((resolve, reject) => {
      API.processing.getList(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  runProcessing({ commit }, { endpoint, data }) {
    return new Promise((resolve, reject) => {
      API.processing.runProcessing(
        endpoint,
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Home/processing.js